import { getAccountLookupForm, } from '@/store/modules/accountLookup';
import Vue from 'vue';
export default Vue.extend({
    data: () => ({
        labels: {
            fullName: 'Nama Lengkap',
            motherName: 'Nama Ibu Kandung',
            userType: 'Tipe Pengguna',
            dateOfBirth: 'Tanggal Lahir',
            npsn: 'NPSN',
        },
        userTypes: {
            student: 'Siswa',
            teacher: 'Pendidik dan Tenaga Kependidikan',
        },
    }),
    computed: {
        localForm() {
            return getAccountLookupForm();
        },
        visibleForm() {
            /* eslint-disable @typescript-eslint/no-unused-vars */
            const { placeOfBirth, ...rest } = this.localForm || {};
            rest.userType = this.userTypes[rest.userType];
            return rest;
        },
    },
});
